import { ButtonGroup, ButtonIcon } from '@statsbomb/kitbag-components';
import { useAtom } from 'jotai';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { tableSelectedRowIdsAtom } from '@/atoms/table';
import { EditColumnsButton } from '@/components/button/EditColumnsButton';
import { SavePlayersToShortlistsWithNavigate } from '@/components/shortlists/SavePlayersToShortlistsWithNavigate';
import { ExportCsvMenuItem } from '../export/ExportCsvMenuItem';
import { MoreOptionsMenu } from '../menu/MoreOptionsMenu/MoreOptionsMenu';
import { SectionControlsWrapper } from './SectionControlsWrapper';

export const TableDataControls = ({ heading, children }: { heading: string; children?: ReactNode }) => {
  const [selectedRowIds, setSelectedRowIds] = useAtom(tableSelectedRowIdsAtom);
  const isButtonGroupVisible = selectedRowIds.length > 0;
  const { t } = useTranslation('table');

  return (
    <SectionControlsWrapper
      heading={selectedRowIds.length > 0 ? '' : heading}
      headerComponent={
        // we need this visibility trick to avoid ActionMessage in kitbag-shortlists disappearing when SavePlayersToShortlists is not rendered
        <div className={isButtonGroupVisible ? 'visible' : 'invisible'}>
          <ButtonGroup>
            <ButtonIcon
              id="selected-rows-button"
              variant="secondary"
              displayText="right"
              icon="Close"
              ariaLabel={t('buttonGroupSelectedRows', { count: selectedRowIds.length })}
              onClick={() => setSelectedRowIds([])}
              size="small"
            >
              {
                (
                  <span className="hidden xl:inline">
                    {t('buttonGroupSelectedRows', { count: selectedRowIds.length })}
                  </span>
                ) as unknown as string
              }
            </ButtonIcon>
            <SavePlayersToShortlistsWithNavigate playerIds={selectedRowIds} onAfterSave={() => setSelectedRowIds([])} />
          </ButtonGroup>
        </div>
      }
    >
      {children}
      <EditColumnsButton />
      <MoreOptionsMenu>
        <ExportCsvMenuItem />
      </MoreOptionsMenu>
    </SectionControlsWrapper>
  );
};
